import { Product } from "@/api/product-api";
import React from "react";
import ProductCard from "@/v2-components/ProductCard";
import { cn } from "@/libs/utils";
import { ProductUtil } from "@/utils/ProductUtil";

export default function DisplayProducts({
  className,
  products,
}: {
  className?: string;
  products: Product[];
}) {
  const hasMadeForMeta = products.some((product) =>
    ProductUtil.isMadeForMeta(product.slug),
  );
  return (
    <div
      className={cn("grid grid-cols-2 gap-y-8 laptop:grid-cols-4", className)}
    >
      {products.map((p) => {
        return (
          <ProductCard
            key={p.slug}
            product={p}
            hasMadeForMeta={hasMadeForMeta}
          />
        );
      })}
    </div>
  );
}
